// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"7dc5636a","303":"2c3c27b9","702":"a23f7f09"}[chunkId] + ".chunk.css";
};